import { render } from "./AppLayoutAdmin.vue?vue&type=template&id=3716df74"
import script from "./AppLayoutAdmin.vue?vue&type=script&lang=js"
export * from "./AppLayoutAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__